module.exports = __webpack_public_path__ + "img/name_in_goblet_of_fire.6d9a3065.jpg";